export type PasswordStrengthResult = {
  score: number
  label: string
}

export function getPasswordStrength(password: string): PasswordStrengthResult {
  if (!password) {
    return { score: 0, label: 'Informe uma senha.' }
  }

  let score = 0
  if (password.length >= 8) score += 1
  if (/[A-Z]/.test(password) && /[a-z]/.test(password)) score += 1
  if (/\d/.test(password)) score += 1
  if (/[^A-Za-z0-9]/.test(password)) score += 1

  if (score <= 1) return { score, label: 'Senha fraca.' }
  if (score <= 2) return { score, label: 'Senha média.' }
  if (score === 3) return { score, label: 'Senha boa.' }
  return { score, label: 'Senha forte.' }
}
